import React from 'react';
import {Image} from 'react-bootstrap';
import {AboutMeStyle, TextStyle} from '../assets/css/Styles';
import {Col, Row, OverlayTrigger, Tooltip} from 'react-bootstrap';

/**
 *
 * @param {String} title - to check which technology container to return
 * @return {Component} each technology container me component
 */
export default function TechnologyContainers({...props}) {
  /**
   * @param {String} techName - name on each tool tip
   * @return {Component} tool tip function
   */
  const toolTipFunc = (techName) => {
    return (
      <Tooltip>
        {techName}
      </Tooltip>
    );
  };
  return (
    <Col style={AboutMeStyle.eachTechDiv}>
      <Col style={AboutMeStyle.eachTechTitleDiv}>
        <span style={TextStyle.normalTxt1}>{props.title}</span>
      </Col>
      <Row xl='4' lg='4' md='4' sm='4' xs='4'
        style={AboutMeStyle.eachTechContainer}>
        {
          props.techArray.map((eachTech) => (
            <Col key={eachTech.name}>
              <OverlayTrigger
                placement='right'
                overlay={toolTipFunc(eachTech.name)}
                /* delay={{show: 100, hide: 100}} */>
                <Image
                  alt={eachTech.name}
                  src={eachTech.source}
                  style={AboutMeStyle.eachTechImage}
                />
              </OverlayTrigger>
            </Col>
          ))}
      </Row>
    </Col>

  );
}
